/* Movatic WMS — Frontend | CesarFilho 932048016
   ADR-0056 C1c-1: página de CRUD de "Políticas de shelf-life" (Cadastros → Catálogo).
   Molde: <CrudList writable> (o padrão dos cadastros editáveis; o modal de criar/editar é o
   <DynamicForm> genérico, auto-construído do schema DRF OPTIONS — code/min_days/description/
   is_active). O backend valida a unicidade do `code` (o erro 400 sobe no modal). Contratos NÃO
   entram aqui (é a C1c-2).
   Endpoint (ADR-0056 C1a): /api/partners/shelf-life-policies/ (list/create/update/delete). */
import CrudList from '@/components/CrudList'
import type { Column } from '@/components/DataTable'

export type ShelfLifePolicy = {
  id: number
  code: string
  min_days: number
  description?: string
  is_active: boolean
}

const ENDPOINT = '/api/partners/shelf-life-policies/'

const columns: Column<ShelfLifePolicy>[] = [
  {
    key: 'code',
    header: 'Código',
    render: (r) => <span className="font-mono text-xs">{r.code}</span>,
  },
  { key: 'description', header: 'Descrição' },
  { key: 'min_days', header: 'Dias mínimos' },
  {
    key: 'is_active',
    header: 'Ativo',
    render: (r) => (r.is_active ? 'Sim' : 'Não'),
  },
]

export default function ShelfLifePolicies() {
  return (
    <CrudList
      title="Políticas de shelf-life"
      endpoint={ENDPOINT}
      writable
      columns={columns as any}
    />
  )
}
